import { useLayoutEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const useHome = () => {
  const navigate = useHistory();
  const [loading, setLoading] = useState(false);
  useLayoutEffect(() => {
    const getUser = () => {
      const user = localStorage.getItem("user");
      if (!user) {
        navigate.replace("/auth/");
      }
    };
    getUser();
  }, []);

  return {
    loading,
  };
};
export default useHome;
